import React, { useState } from "react";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";

const IncompletePaymentStrip = ({
  notificationReleasedDate,
  accessRevokeDate,
}) => {
  const [open, setOpen] = useState(true);
  const [modalState, setModalState] = useState(
    localStorage.getItem("modalState")
  );

  const revokeDate = dayjs(accessRevokeDate);
  const today = dayjs();
  const daysLeft = revokeDate.diff(today, "day");

  const formattedDeadline = revokeDate.format("DD MMMM YYYY");

  if (!open) return null;
  const handleDismiss = () => {
    console.log("User dismissed the alert");
    localStorage.setItem("modalState", false);
    setModalState(false);
    setOpen(false);
  };
  return (
    <>
      {modalState ? (
        <>
          {" "}
          <Alert
            variant="filled"
            severity={daysLeft >= 0 ? "warning" : "error"}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              zIndex: 1300,
            }}
            sx={{
              marginTop: { xs: "55px", sm: "63px" },
              backgroundColor: "#D32F2F",
            }}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={handleDismiss}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
          >
            {daysLeft >= 0 ? (
              <>
                <strong>Incomplete Payment:</strong> Your dashboard access will
                be revoked after <strong>{formattedDeadline}</strong> if the
                payment is not completed.{" "}
                <a href="/Duefee" className="underline">
                  [Click here to complete your payment now]
                </a>{" "}
                Only {daysLeft} day
                {daysLeft !== 1 ? "s" : ""} left to make your payment.
              </>
            ) : (
              <>
                <strong>Final Reminder:</strong> The payment deadline of{" "}
                <strong>{formattedDeadline}</strong> has passed. Your dashboard
                access will be <strong>revoked</strong> shortly if the payment
                is not completed.
              </>
            )}
          </Alert>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default IncompletePaymentStrip;
